import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface WebsiteIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const WebsiteIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: WebsiteIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <g id="ic/website &#240;&#159;&#145;&#141;">
                <g id="Group">
                    <path
                        id="Vector"
                        d="M17.8974 21.0993C18.4807 21.0989 19.0399 20.867 19.4523 20.4547C19.8647 20.0423 20.0967 19.483 20.0971 18.8998V6.10186C20.0967 5.5187 19.8648 4.95939 19.4523 4.54697C19.0399 4.13469 18.4807 3.90276 17.8974 3.90234H6.69966C6.11635 3.90275 5.55718 4.13467 5.14477 4.54697C4.73235 4.95939 4.50041 5.51873 4.5 6.10186V18.8998C4.5004 19.483 4.73232 20.0423 5.14477 20.4547C5.55718 20.867 6.11639 21.0989 6.69966 21.0993H17.8974ZM5.69972 18.8998V6.10186C5.70012 5.83686 5.80564 5.58283 5.99297 5.39539C6.18044 5.20806 6.43446 5.10254 6.69958 5.10214H17.8974C18.1625 5.10254 18.4165 5.20806 18.604 5.39539C18.7913 5.58286 18.8968 5.83688 18.8972 6.10186V18.8998C18.8968 19.1648 18.7913 19.4188 18.604 19.6063C18.4165 19.7936 18.1625 19.8991 17.8974 19.8995H6.69958C6.43444 19.8991 6.18041 19.7936 5.99297 19.6063C5.80564 19.4188 5.70012 19.1648 5.69972 18.8998Z"
                        fill={color}
                    />
                    <path
                        id="Vector_2"
                        d="M8.69949 18.2994H15.8982C16.1126 18.2994 16.3106 18.185 16.4178 17.9994C16.5249 17.8139 16.5249 17.5851 16.4178 17.3996C16.3106 17.214 16.1126 17.0996 15.8982 17.0996H8.69949C8.48511 17.0996 8.28708 17.214 8.17995 17.3996C8.07283 17.5851 8.07283 17.8139 8.17995 17.9994C8.28708 18.185 8.48512 18.2994 8.69949 18.2994Z"
                        fill={color}
                    />
                    <path
                        id="Vector_3"
                        d="M8.69949 15.901H15.8982C16.1126 15.901 16.3106 15.7866 16.4178 15.601C16.5249 15.4154 16.5249 15.1867 16.4178 15.0011C16.3106 14.8155 16.1126 14.7012 15.8982 14.7012H8.69949C8.48511 14.7012 8.28708 14.8155 8.17995 15.0011C8.07283 15.1867 8.07283 15.4154 8.17995 15.601C8.28708 15.7866 8.48512 15.901 8.69949 15.901Z"
                        fill={color}
                    />
                    <path
                        id="Vector_4"
                        d="M9.29883 12.9015C9.29883 13.1157 9.41318 13.3137 9.59877 13.4209C9.78437 13.5281 10.0131 13.5281 10.1987 13.4209C10.3843 13.3137 10.4986 13.1157 10.4986 12.9015C10.4986 12.2584 10.8417 11.6643 11.3985 11.3428C11.9552 11.0213 12.6414 11.0213 13.1981 11.3428C13.7549 11.6643 14.098 12.2584 14.098 12.9015C14.098 13.1157 14.2123 13.3137 14.3979 13.4209C14.5835 13.5281 14.8122 13.5281 14.9978 13.4209C15.1834 13.3137 15.2978 13.1157 15.2978 12.9015C15.2963 11.9206 14.815 11.0025 14.0092 10.4435C14.5435 9.97645 14.8635 9.31136 14.8953 8.60245C14.927 7.89355 14.6675 7.20247 14.1771 6.68962C13.6866 6.1769 13.0079 5.88672 12.2983 5.88672C11.5887 5.88672 10.91 6.17689 10.4195 6.68962C9.92909 7.20247 9.6696 7.89355 9.70134 8.60245C9.73308 9.31136 10.0531 9.97645 10.5874 10.4435C9.78155 11.0026 9.3003 11.9206 9.29883 12.9015ZM10.8986 8.50236V8.50222C10.8986 8.13104 11.046 7.77498 11.3085 7.51254C11.5711 7.24995 11.9271 7.10252 12.2983 7.10252C12.6695 7.10252 13.0255 7.24995 13.2881 7.51254C13.5506 7.77499 13.698 8.13104 13.698 8.50222C13.698 8.87354 13.5506 9.2296 13.2881 9.49205C13.0255 9.7545 12.6695 9.90207 12.2983 9.90207C11.9273 9.90167 11.5715 9.75397 11.309 9.4915C11.0466 9.22918 10.899 8.8734 10.8986 8.50222V8.50236Z"
                        fill={color}
                    />
                </g>
            </g>
        </svg>
    )
}

export default WebsiteIcon
